@if (isShown && isMenuReady) {
  <aside class="main-sidebar elevation-4">
    <a href="/" class="brand-link logo-switch" [title]="'DEPOTO'">
      <img src="assets/img/dt-icon.svg" alt="Depoto" class="brand-image-xl logo-xs" data-cy="small-logo" />
      <img src="assets/img/group559.svg" alt="Depoto" class="brand-image-xs logo-xl" data-cy="big-logo" />
    </a>
    <div class="sidebar">
      <nav class="mt-2">
        <ul
          class="nav nav-pills nav-sidebar flex-column nav-collapse-hide-child"
          data-widget="treeview"
          role="menu"
          data-accordion="true"
        >
          @for (item of menuItems; track item) {
            @if (item && !item.sublinks && item.show) {
              <li class="nav-item">
                <a
                  [routerLink]="item.link"
                  class="nav-link nav-link-main"
                  [ngClass]="{ active: isActiveLink(item) }"
                  [title]="item.title"
                  (click)="handleSubtree($event)"
                >
                  <i class="nav-icon far fa-{{ item.icon }}"></i>
                  <p class="nav-link-label" data-cy="nav-items">{{ item.title }}</p>
                </a>
              </li>
            }
            @if (item && item.sublinks && item.show) {
              <li class="nav-item has-treeview">
                <a
                  href="#"
                  class="nav-link submenu-main"
                  [ngClass]="{ active: isParentActive(item) }"
                  [title]="item.title"
                  (click)="handleSubtree($event)"
                >
                  <i class="nav-icon far fa-{{ item.icon }}"></i>
                  <p class="nav-link-label" data-cy="more-nav-items">{{ item.title }}</p>
                  <i class="right fa fa-angle-left"></i>
                </a>
                <ul class="nav nav-treeview submenu">
                  @for (subitem of item.sublinks; track subitem) {
                    @if (subitem.show) {
                      <li class="nav-item" [ngClass]="{ 'active-border': isActiveLink(subitem) }">
                        <a
                          [routerLink]="subitem.link"
                          class="nav-link nav-link-sub"
                          [ngClass]="{ 'active-submenu': isActiveLink(subitem) }"
                          [title]="subitem.title"
                        >
                          <i class="nav-icon far fa-{{ subitem.icon }}"></i>
                          <p data-cy="sub-nav-items">{{ subitem.title }}</p>
                        </a>
                      </li>
                    }
                  }
                </ul>
              </li>
            }
          }
        </ul>
      </nav>
    </div>
  </aside>
}
